import React, { useEffect, useState } from "react";
import API from "../lib/TimeEditAPI";
import ArrayInput from "./ArrayInput";
import _ from "underscore";
import { TComponent } from "../types/utils";

const DEFAULT_SIZE = 5;

type TColorType = { id: number; name: string };

type TColorTypeInputProps = {
    defaultValue: number[];
    onUpdate: (...args: any[]) => any;
    limit?: number;
    defaultSize?: number;
    /** Passed by Settings but unused here; kept so the prop is accounted for. */
    size?: number;
};

const ColorTypeInput: TComponent<TColorTypeInputProps> = (props) => {
    const [types, setTypes] = useState<TColorType[]>([]);

    useEffect(() => {
        API.getColorTypes((found) => {
            setTypes([{ id: 0, name: "-" }].concat(found));
        });
    }, []);

    const options = types.map((type) => ({
        value: type.id,
        label: type.name,
        selected:
            _.contains(props.defaultValue, type.id) ||
            (type.id === 0 && props.defaultValue.length === 0),
    }));
    return (
        <ArrayInput
            defaultValue={options}
            disabled={types.length === 0}
            onUpdate={props.onUpdate}
            limit={props.limit || 0}
            defaultSize={props.defaultSize || DEFAULT_SIZE}
        />
    );
};

export default ColorTypeInput;
